import React from "react";
import DecorativeSquares from "../../components/ui/DecorativeSquares";

const ShimmerBox = ({ className = "" }) => (
  <div className={`  rounded-md shimmer ${className}`}></div>
);

const EditSubscShimmer = () => {
  return (
    <section className="relative max-w-7xl mx-auto px-4 py-6 max-h-screen">
      <DecorativeSquares />

      {/* Header */}
      <div className="flex items-center h-14 mt-5 bg-white px-8 shadow-sm">
        <ShimmerBox className="h-8 w-8 rounded-full" />
        <ShimmerBox className="h-6 w-48 mx-auto" />
      </div>

      <div className="mx-auto max-w-7xl mt-6">
        <div className="bg-white rounded-md p-6 shadow-md">
          <div className="space-y-6">
            {/* Customer input */}
            <div>
              <ShimmerBox className="h-4 w-24 mb-2" />
              <ShimmerBox className="h-10 w-full" />
            </div>

            {/* Meal card */}
            <div>
              <ShimmerBox className="h-4 w-20 mb-3" />
              <div className="flex gap-4 bg-gray-100 p-4 rounded-xl">
                <ShimmerBox className="h-12 w-12 rounded-md" />
                <div className="flex flex-col gap-2 flex-1">
                  <ShimmerBox className="h-4 w-40" />
                  <ShimmerBox className="h-4 w-28" />
                </div>
              </div>
            </div>

            {/* Quantity */}
            <div>
              <ShimmerBox className="h-4 w-20 mb-3" />
              <div className="flex gap-3">
                <ShimmerBox className="h-8 w-8" />
                <ShimmerBox className="h-8 w-8" />
                <ShimmerBox className="h-8 w-8" />
              </div>
            </div>

            {/* Extra items */}
            <div className="border border-gray-200 rounded-lg p-4 space-y-4">
              <ShimmerBox className="h-4 w-28" />

              {[1, 2].map((i) => (
                <div key={i} className="flex justify-between items-center">
                  <div className="space-y-2">
                    <ShimmerBox className="h-4 w-32" />
                    <ShimmerBox className="h-3 w-24" />
                  </div>

                  <div className="flex items-center gap-4">
                    <div className="flex gap-2">
                      <ShimmerBox className="h-7 w-7" />
                      <ShimmerBox className="h-5 w-6" />
                      <ShimmerBox className="h-7 w-7" />
                    </div>
                    <ShimmerBox className="h-4 w-16" />
                  </div>
                </div>
              ))}
            </div>

            {/* Plan type */}
            <div>
              <ShimmerBox className="h-4 w-24 mb-2" />
              <ShimmerBox className="h-10 w-full" />
            </div>

            {/* Plan summary card */}
            <ShimmerBox className="h-16 w-full rounded-xl" />

            {/* Start date */}
            <ShimmerBox className="h-4 w-40" />

            {/* Meal timing */}
            <div>
              <ShimmerBox className="h-4 w-24 mb-2" />
              <ShimmerBox className="h-10 w-full" />
            </div>

            {/* Delivery type */}
            <div>
              <ShimmerBox className="h-4 w-28 mb-3" />
              <div className="flex gap-4">
                <ShimmerBox className="h-6 w-32" />
                <ShimmerBox className="h-6 w-24" />
              </div>
            </div>

            {/* Address */}
            <ShimmerBox className="h-14 w-full" />

            {/* Per order amount */}
            <div>
              <ShimmerBox className="h-4 w-32 mb-2" />
              <ShimmerBox className="h-10 w-full" />
              <ShimmerBox className="h-3 w-40 mt-3" />
            </div>
          </div>

          {/* Continue button */}
          <div className="flex justify-end mt-6">
            <ShimmerBox className="h-10 w-32 rounded-xl" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default EditSubscShimmer;
